var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetsUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 20C40.0004 31.046 31.0464 40 20.0004 40C8.95479 40 0.000396729 31.046 0.000396729 20C0.000396729 8.9542 8.95479 0 20.0004 0C31.0464 0 40.0004 8.9542 40.0004 20Z",
    fill: "#1BA27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3867 10.085H10.4487V14.657H17.6317V21.377H22.2037V14.657H29.3867V10.085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9617 22.0928C14.0197 22.0928 9.20232 21.1524 9.20232 19.9922C9.20232 18.8322 14.0195 17.8916 19.9617 17.8916C25.9037 17.8916 30.7209 18.8322 30.7209 19.9922C30.7209 21.1524 25.9037 22.0928 19.9617 22.0928ZM32.0427 20.3424C32.0427 18.8464 26.6339 17.6338 19.9617 17.6338C13.2897 17.6338 7.88052 18.8464 7.88052 20.3424C7.88052 21.6598 12.0747 22.7574 17.6325 23.0006V32.6474H22.2041V23.0044C27.8047 22.7688 32.0427 21.6666 32.0427 20.3424Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 4,
    fill: "#6DE7B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsUsdt);
export default __webpack_public_path__ + "static/media/assetsUsdt.cc0a8fcadfb5da1fd83e1a7bc2380318.svg";
export { ForwardRef as ReactComponent };